import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Instant top — needed on iOS, which often restores scroll after the first paint. */
function scrollWindowToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/**
 * Resets window scroll on route changes so long pages (landing → article)
 * do not open mid-page. Hash navigations are left alone for in-page anchors.
 * Manual restoration stops the browser from restoring mid-page scroll on refresh.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname === "/") {
      window.history.scrollRestoration = "auto";
      return;
    }
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = previous;
    };
  }, [pathname]);

  useEffect(() => {
    if (hash || pathname === "/") return;
    scrollWindowToTop();
    const frame = window.requestAnimationFrame(scrollWindowToTop);
    const t = window.setTimeout(scrollWindowToTop, 50);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(t);
    };
  }, [pathname, hash]);

  return null;
}
